export function UnitConversion(value, system, unit) {
  if (system === 'metric') {
    return {
      displayedValue: value,
      displayedUnit: unit,
    };
  }

  let type = null;
  if (unit === 'mm') type = 'length';
  if (unit === 'm') type = 'lengthMeter';
  if (unit === 'kg') type = 'weight';
  if (unit === 'kg/m') type = 'linearWeight';
  if (unit === 'Nm') type = 'torque';
  if (unit === 'm/min') type = 'speed';

  const conversions = {
    length: {
      metric: { factor: 1, unit: 'mm' },
      imperial: { factor: 1 / 25.4, unit: 'in' },
    },
    lengthMeter: {
      metric: { factor: 1, unit: 'm' },
      imperial: { factor: 3.281, unit: 'ft' },
    },
    weight: {
      metric: { factor: 1, unit: 'kg' },
      imperial: { factor: 2.205, unit: 'lb' },
    },
    linearWeight: {
      metric: { factor: 1, unit: 'kg/m' },
      imperial: { factor: 2.205 / 3.281, unit: 'lb/ft' },
    },
    torque: {
      metric: { factor: 1, unit: 'Nm' },
      imperial: { factor: 0.737562, unit: 'lb·ft' },
    },
    speed: {
      metric: { factor: 1, unit: 'm/min' },
      imperial: { factor: 3.281, unit: 'ft/min' },
    },
  };

  const target =
    type && conversions[type][system]
      ? conversions[type][system]
      : { factor: 1, unit };

  const numericValue =
    typeof value === 'number'
      ? value
      : typeof value === 'string' && value.trim() !== ''
        ? Number(value)
        : NaN;

  if (Number.isNaN(numericValue)) {
    return {
      displayedValue: value,
      displayedUnit: target.unit,
    };
  }

  return {
    displayedValue: Math.round(numericValue * target.factor * 10000) / 10000,
    displayedUnit: target.unit,
  };
}

export function ToBaseUnit(value, unit) {
  const numericValue =
    typeof value === 'number'
      ? value
      : typeof value === 'string' && value.trim() !== ''
        ? Number(value)
        : NaN;

  if (!Number.isNaN(numericValue)) {
    switch (unit) {
      case 'in':
        value = numericValue * 25.4;
        break;

      case 'ft':
        value = numericValue / 3.281;
        break;

      case 'lb':
        value = numericValue / 2.205;
        break;

      case 'lb/ft':
        value = (numericValue * 3.281) / 2.205;
        break;

      case 'lb·ft':
        value = numericValue / 0.737562;
        break;

      case 'ft/min':
        value = numericValue / 3.281;
        break;

      default:
        value = numericValue;
    }

    value = Math.round(value * 100) / 100;
  }
  return value;
}

export function ConvertOptionList(options, system, unit) {
  if (!Array.isArray(options)) return options;

  return options.map((opt) => {
    const numeric = toNumeric(opt);

    if (numeric === null) return opt;

    const { displayedValue } = UnitConversion(numeric, system, unit);

    return displayedValue;
  });
}

function toNumeric(val) {
  if (typeof val === 'number') return val;
  if (typeof val === 'string' && val.trim() !== '') {
    const n = Number(val);
    return Number.isNaN(n) ? null : n;
  }
  return null;
}
